/**
 * src/lib/nhatKy.js — nhật ký hành trình ẩn danh cho /admin/thong-ke.
 *
 * Mỗi lượt xem trang và mỗi thao tác quan trọng là một bản ghi trong
 * collection `su_kien`. Trình duyệt chỉ được TẠO, không đọc, sửa hay xoá
 * (firestore.rules). Chỉ quản trị viên đọc được.
 *
 * Bản ghi KHÔNG chứa danh tính: mã phiên là chuỗi ngẫu nhiên sinh cho từng
 * tab và mất khi đóng tab; không có email, UID, IP hay số liệu người dùng nhập.
 * Trường `hetHan` để Firestore tự xoá bản ghi sau 180 ngày (bật TTL, xem
 * ANALYTICS.md).
 *
 * Được gọi từ src/lib/track.js, SAU khi đã kiểm tra sự đồng ý.
 * Tắt riêng phần này bằng VITE_NHAT_KY=off trong .env.
 */
import { CO_CAU_HINH, layDb } from './firebase.js';
import { taoBanGhi, nhanDienNguon } from './statsModel.js';

const ENV = import.meta.env || {};
export const NHAT_KY_BAT = CO_CAU_HINH && ENV.VITE_NHAT_KY !== 'off';

const NGAY_LUU = 180;
const TRAN_MOI_PHIEN = 300; // chặn vòng lặp lỗi ghi hàng nghìn bản ghi

function ss(k, v) {
  try {
    if (v === undefined) return sessionStorage.getItem(k);
    sessionStorage.setItem(k, v);
  } catch { return null; }
  return v;
}

export function maPhien() {
  let id = ss('fvn-phien');
  if (!id || !/^[a-z0-9]{12}$/.test(id)) {
    const a = new Uint8Array(12);
    (window.crypto || {}).getRandomValues?.(a);
    id = Array.from(a, (b) => 'abcdefghijklmnopqrstuvwxyz0123456789'[b % 36]).join('');
    if (!/^[a-z0-9]{12}$/.test(id)) id = Math.random().toString(36).slice(2, 14).padEnd(12, '0');
    ss('fvn-phien', id);
  }
  return id;
}

let soGhi = 0;

export async function ghiNhatKy(ten, trang, params) {
  if (!NHAT_KY_BAT || typeof window === 'undefined') return;
  if (++soGhi > TRAN_MOI_PHIEN) return;
  const phien = maPhien();
  // Nguồn truy cập chỉ ghi ở bản ghi đầu tiên của phiên.
  let nguon;
  if (!ss('fvn-phien-nguon')) {
    nguon = nhanDienNguon(document.referrer, window.location.search, window.location.hostname);
    ss('fvn-phien-nguon', '1');
  }
  const thietBi = window.matchMedia?.('(max-width: 760px)').matches ? 'mobile' : 'desktop';
  const rec = taoBanGhi({ ten, trang, phien, params, nguon, thietBi });
  if (!rec) return;
  try {
    const db = await layDb();
    if (!db) return;
    const { collection, addDoc, serverTimestamp, Timestamp } = await import('firebase/firestore/lite');
    await addDoc(collection(db, 'su_kien'), {
      ...rec,
      createdAt: serverTimestamp(),
      hetHan: Timestamp.fromMillis(Date.now() + NGAY_LUU * 864e5),
    });
  } catch { /* đo lường không bao giờ được làm hỏng trải nghiệm */ }
}

/** Quản trị: đọc nhật ký trong N ngày gần nhất. */
export async function docNhatKy(soNgay = 7, tran = 5000) {
  const db = await layDb();
  if (!db) throw new Error('Website chưa cấu hình Firestore.');
  const { collection, getDocs, query, where, orderBy, limit, Timestamp } = await import('firebase/firestore/lite');
  const tu = Timestamp.fromMillis(Date.now() - soNgay * 864e5);
  const snap = await getDocs(query(collection(db, 'su_kien'), where('createdAt', '>=', tu), orderBy('createdAt', 'desc'), limit(tran)));
  return { banGhi: snap.docs.map((d) => d.data()), catBot: snap.size >= tran };
}
